import React from 'react';
import { Youtube, Twitter } from 'lucide-react';
import { KickLogo, DiscordLogo } from '../SocialIcons';
import { SOCIAL_URLS } from '../../content/socials';
import { REWARDS_DISCORD_URL } from '../../content/rewards';

const links = [
  ['YouTube', SOCIAL_URLS.youtube, Youtube], ['Kick', process.env.REACT_APP_KICK_CHANNEL_URL, KickLogo],
  ['Twitter', SOCIAL_URLS.twitter, Twitter], ['Discord', REWARDS_DISCORD_URL, DiscordLogo],
];
export const MaintenanceSocials = () => <section className="maintenance-socials" data-testid="maintenance-socials" aria-label="GVRewards community">
  <p data-testid="maintenance-socials-label">The community is still here</p>
  <div>{links.map(([label, href, Icon]) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" data-social-brand={label.toLowerCase()} data-testid={`maintenance-social-${label.toLowerCase()}`} title={label} aria-label={`GVRewards on ${label}`}><Icon size={20} aria-hidden="true" /></a>)}</div>
</section>;